
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { ALERT_COLORS } from '@/store/base'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BaseAlert, BaseFormSubmit, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)

    const schema = yup.object({
      password_current: yup.string().required().min(8).max(255),
      password: yup.string().required().min(8).max(255),
      password_confirmation: yup.string().required().min(8).oneOf([yup.ref('password'), null], t('validation.password_confirmation')),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema })

    const { value: password_current } = useField('password_current')
    const { value: password } = useField('password')
    const { value: password_confirmation } = useField('password_confirmation')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-password', {
          password_current: values.password_current,
          password: values.password,
        })
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('account.change_password.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      password_current,
      password,
      password_confirmation,
      onSubmit,
      btnDisabled
    }
  },
})
